import React from 'react'
import Skeleton from 'react-loading-skeleton'
import { useTranslation } from 'react-i18next'

import FieldLabelWrapper from '../../../../features/components/Form/FieldLabelWrapper'

import useCommonStyles from '../../../../styles/common/listPage'

function RightHolderProfileFormSkeleton() {
  const { t } = useTranslation()

  const commonClasses = useCommonStyles()

  return (
    <>
      <div className={commonClasses.formRow}>
        <FieldLabelWrapper label={t('Name')}>
          <Skeleton style={{ height: 30, marginTop: 5 }} />
        </FieldLabelWrapper>
        <FieldLabelWrapper label={t('Icon')}>
          <Skeleton style={{ height: 30, marginTop: 5 }} />
        </FieldLabelWrapper>
      </div>
      <div className={commonClasses.formRow}>
        <FieldLabelWrapper label={t('Facebook Business Manager ID')}>
          <Skeleton style={{ height: 30, marginTop: 5 }} />
        </FieldLabelWrapper>
        {/* don't delete this div, it's a workaround to keep layout aligned with not equal columns */}
        <div style={{ width: '100%' }}></div>
      </div>
    </>
  )
}

export default RightHolderProfileFormSkeleton
